import {DEFAULT_AGENDA_PARAMS as SHARED_DEFAULT_AGENDA_PARAMS} from "@sfs/utils/agendaUtilities";

// Common agenda utilities live in @shared/utils/agendaUtilities (shared with
// inscription-front). Orga-only symbols and the orga-extended default params
// stay here, behind the same import path for consumers.
export {
  CELL_DURATION_MINUTES,
  CELLS_DISPLAY_HEIGHTS,
  getAgendaDisplayStartDate,
  getNumberOfDaysToDisplay,
  getSessionElementsFromListInSlot,
  slotNumberString,
} from "@sfs/utils/agendaUtilities";

// Max recommended number of simultaneous columns
export const RECOMMENDED_LIMIT_OF_RESOURCE_COLUMNS = 15;

// DEFAULT AGENDA PARAMS (orga extends the shared base with resource display config)
export const DEFAULT_AGENDA_PARAMS = {
  ...SHARED_DEFAULT_AGENDA_PARAMS,
  defaultNewSlotDuration: 90,
  displayAvailabilities: true,
  selectedResources: [],
  showResourcesListingOnAgendaCards: [
    "places",
    "stewards",
    "registrations",
    "maxNumberOfParticipants",
    "activityTags",
    "sessionTags",
  ],
  resourcesFilterSelections: {},
  showResourcesAvailabilities: {},
};

/**
 * Why: When cloning a session by alt-dropping an agenda slot, the drop target group
 * determines the places/stewards; without this, the clone inherits the original
 * session's places/stewards and lands in the wrong resource column.
 * What: Builds a "new" session payload from the original session and the dragged slot,
 * applying the slot's changedPlaces/changedStewards at session level (places/stewards
 * are session-level fields) and stripping those view-only fields from the slot.
 * Test: agendaUtilities.test.ts > getSessionClonedFromSlot
 */
export const getSessionClonedFromSlot = (session: any, slot: any) => {
  const {changedPlaces, changedStewards, ...cleanSlot} = slot;
  return {
    ...session,
    _id: "new",
    ...(changedPlaces?.length && {places: changedPlaces}),
    ...(changedStewards?.length && {stewards: changedStewards}),
    slots: [{...cleanSlot}],
  };
};
